import React from 'react';

import {colors} from '../../colors/colors';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Stop from './icon-stop.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Stop {...validProps} color={validProps.color ? validProps.color : colors.black} />;
}
SvgComponent.iconName = 'stop';

/**
 * @deprecated This is a legacy icon
 */
export const StopIcon = svgIconWrapper(SvgComponent);
